import React from 'react';
import { Route, IndexRoute } from 'react-router';

import CartScreen from 'ggApp/shared/screens/Cart';
import NewCheckoutScreenComponent from 'ggApp/shared/screens/NewCheckout';
// Routes
import CartWrap from './_wrap';

const CartRoutes = ({ newCheckoutFlag }) => {
    if (newCheckoutFlag) {
        return <Route path="cart" component={NewCheckoutScreenComponent} />;
    }
    return (
        <Route path="cart" component={CartWrap}>
            <IndexRoute
                name="cartHome"
                component={CartScreen}
                orderStep={{
                    state: 'cart',
                    step: 'cart',
                }}
            />
        </Route>
    );
};

export default CartRoutes;
